// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".w-180[data-v-6243eab6]{width:120px}.dictionaryItems-panel[data-v-6243eab6]{max-height:300!important;overflow:auto}", ""]);
// Exports
module.exports = exports;
